module.exports = __webpack_public_path__ + "img/engagement_10.2bb53fb0.jpg";